/* Keep the original campaign attribution on the next step of this product story. */
(() => {
  const incoming = new URLSearchParams(window.location.search);
  const allowed = /^(utm_(source|medium|campaign|content|term|id|source_platform|creative_format|marketing_tactic)|gclid|gbraid|wbraid|tw_source|tw_adid|tw_campaign|tw_kwdid|soph_lp_test|soph_lp_arm)$/;
  document.querySelectorAll('[data-soph-presale-cta]').forEach((link) => {
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || destination.pathname !== '/products/amity-necklace-personalised') return;
    incoming.forEach((value, key) => {
      if (allowed.test(key)) destination.searchParams.set(key, value);
    });
    link.href = destination.href;
  });
})();
